Vue.asyncComponent('cms-settings-menu', {
    data() {
        return {
            menu: this.$userInterfaceHandler.getUserInterface()?.menuSettings
        }
    },
    watch: {
        '$userInterfaceHandler.userInterface': {
            handler() {
                this.menu =  this.$userInterfaceHandler.getUserInterface()?.menuSettings;
            }, deep: true
        }
    },
}, 'cms/layout/cms-settings-menu.html');